import { Link } from 'react-router-dom';

export default function SuccessScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-50 to-white flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
            <i className="ri-checkbox-circle-line text-green-500 text-4xl"></i>
          </div>
        </div>

        {/* Title */}
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Onboarding Completed Successfully!
          </h1>
          <p className="text-sm text-gray-500">
            Your login credentials have been sent to both your registered and onboarding email addresses.
          </p>
        </div>

        {/* What Happens Next Box */}
        <div className="bg-gray-50 rounded-xl p-5 mb-6">
          <h3 className="text-sm font-bold text-gray-900 text-center mb-4">
            What Happens Next?
          </h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-mail-check-line text-teal-500 text-lg"></i>
              </div>
              <p className="text-sm text-gray-700">
                <strong>Check your emails</strong> (registered and onboarding) for your login password
              </p>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-login-box-line text-teal-500 text-lg"></i>
              </div>
              <p className="text-sm text-gray-700">
                <strong>Login</strong> with your email and the password sent to you
              </p>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-dashboard-line text-teal-500 text-lg"></i>
              </div>
              <p className="text-sm text-gray-700">
                Access your <strong>Marketing 4Sight Dashboard</strong> with detailed insights
              </p>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-line-chart-line text-teal-500 text-lg"></i>
              </div>
              <p className="text-sm text-gray-700">
                Start tracking your brand&apos;s <strong>growth</strong> through SEO
              </p>
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 mb-6">
          <Link
            to="/?login=true"
            className="flex-1 px-6 py-3 bg-teal-500 text-white rounded-lg text-sm font-medium hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            Go to Login
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/"
            className="flex-1 px-6 py-3 bg-white border border-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap text-center"
          >
            Back to Home
          </Link>
        </div>

        {/* Help Footer */}
        <p className="text-center text-xs text-gray-500">
          Need Help? Contact us at <a href="mailto:support@quantyraanalytics.com" className="text-teal-600 hover:underline cursor-pointer">support@quantyraanalytics.com</a>
        </p>
      </div>
    </div>
  );
}